/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import * as yup from "yup";

const requiredWhenBusiness = {
    is: true,
    then: yup => yup.required("Company name is required"),
};

const requiredOnPackage = {
    is: true,
    then: yup => yup.required(),
};

let EMAIL_REGX =
    /^(([^<>()\[\]\\.,;:\s@"]+(.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/;

export const AddressMandatorySchema = yup.object().shape({
    cin: yup.string(),
    city: yup.string().when("required_on_package", requiredOnPackage).when("company_type", requiredWhenBusiness),
    company_name: yup.string().when("company_type", requiredWhenBusiness),
    company_type: yup.boolean().required("Company is required"),
    email: yup.string().matches(EMAIL_REGX, "Invalid email format").required(),
    first_name: yup.string().required("Name missing"),
    is_newsletter_enabled: yup.bool(),
    last_name: yup.string().required("Last name must be filled"),
    notification_method: yup.string().oneOf(["email", "phone"]),
    phone: yup.string().min(12).required(),
    postal_code: yup.string().when("required_on_package", requiredOnPackage).when("company_type", requiredWhenBusiness),
    required_on_package: yup.boolean().required(),
    reservation_note: yup.string(),
    street_address: yup.string().when("required_on_package", requiredOnPackage).when("company_type", requiredWhenBusiness),
    tos: yup.bool().oneOf([true], "Field must be checked"),
    tos_verifier: yup.bool().oneOf([true], "Field must be checked"),
});

export const AddressMandatoryArboparkSchema = yup.object().shape({
    cin: yup.string(),
    city: yup.string().required(),
    company_name: yup.string().when("company_type", requiredWhenBusiness),
    company_type: yup.boolean().required("Company type is required"),
    email: yup.string().matches(EMAIL_REGX, "Invalid email format").required(),
    first_name: yup.string().required("Name missing"),
    is_newsletter_enabled: yup.bool(),
    last_name: yup.string().required("Last name must be filled"),
    notification_method: yup.string().oneOf(["email", "phone"]),
    phone: yup.string().min(12).required(),
    postal_code: yup.string().required(),
    required_on_package: yup.boolean().required(),
    reservation_note: yup.string(),
    street_address: yup.string().required(),
    tos: yup.bool().oneOf([true], "Field must be checked"),
    tos_verifier: yup.bool().oneOf([true], "Field must be checked"),
});